<template>
  <ul itemscope itemtype="https://schema.org/BreadcrumbList">
    <li
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <router-link to="/" title="Главная" itemprop="item">
        <span itemprop="name">Главная</span>
        <meta itemprop="position" content="0" />
      </router-link>
    </li>
    <li
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      v-if="subPath[0]"
    >
      <router-link :to="subPath[0]['path']" itemprop="item">
        <span itemprop="name"> {{ subPath[0]["name"] }} </span>
        <meta itemprop="position" content="1" />
      </router-link>
    </li>
    <li
      v-if="title"
    >
      <span class="title" >
        <span> {{ title }} </span>
      </span>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    title: String,
  },
  data() {
    return {
      subPath: [],
    };
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      let uri = this.$route.path.split("/");
      this.subPath = this.$router.options.routes.filter(function (item) {
        return item.path == `/${uri[1]}s`;
      });
    }
  },
};
</script>
<style scoped>
ul {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
}
ul li {
  display: inline; /* Отображать как строчный элемент */
  margin-right: 5px; /* Отступ слева */
  padding: 3px; /* Поля вокруг текста */
}
ul li a,
ul li span {
  color: #fff;
}
ul li:not(:first-child) a::before,
ul li span.title::before {
  content: "•";
  padding-right: 7px;
}
@media (max-width: 992px) {
    ul{
        position: relative;
    }
}
</style>
